import { fromJS } from 'immutable';
import { moduleName } from '../constants';

const IS_HIGH_VOL_GUID = `${moduleName}/IS_HIGH_VOL_GUID`;
const IS_AAM = `${moduleName}/IS_AAM`;

const initialState = fromJS({
  isHighVolGuid: false,
  isAAM: false,
});

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case IS_HIGH_VOL_GUID:
      return state.set('isHighVolGuid', action.value);
    case IS_AAM:
      return state.set('isAAM', action.value);
    default:
      return state;
  }
};

const setIsHighVolGuid = (value) => ({
  type: IS_HIGH_VOL_GUID,
  value,
});

const setIsAAM = (value) => ({
  type: IS_AAM,
  value,
});

export default reducer;

export {
  IS_HIGH_VOL_GUID,
  IS_AAM,
  setIsHighVolGuid,
  setIsAAM,
};
